'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z' });

var FilterNone = function FilterNone(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

FilterNone = (0, _pure2.default)(FilterNone);
FilterNone.muiName = 'SvgIcon';

exports.default = FilterNone;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/FilterNone.js
// module id = 2401
// module chunks = 0